import React from 'react';
import { StyledGhostBalance } from 'templates/Balances/Ghost/style';
import { formattingNumber } from 'utils/index';
import { NumberConfig } from 'utils/types';

interface GhostBalance {
  image: string;
  amount: number | string;
}
export interface GhostBalanceProps {
  balance: GhostBalance;
  balanceQuantityFormat?: NumberConfig;
}

export const GhostBalance: React.FC<GhostBalanceProps> = ({
  balance,
  balanceQuantityFormat,
}) => {
  return (
    <StyledGhostBalance>
      <div className="img-container">
        <img
          className="img-container--balance"
          alt="balance"
          src={balance.image}
        />
      </div>
      <span>
        {balanceQuantityFormat
          ? formattingNumber({
              number: balance.amount,
              config: balanceQuantityFormat,
              multiplier: 100,
            })
          : balance.amount}
      </span>
    </StyledGhostBalance>
  );
};
